/**
 * @file paddle hack awards
 * @author wanzhongyun
 */

import React from 'react';
import { RightOutlined } from '@ant-design/icons';
import { RootObject } from '../../type';

import './style.less';


const HackAwards = (props: RootObject["hackathonAwards"]) => {

    const {
        titleImageUrl,
        detailLink,
        commonAwardsImg,
        subTitle
    } = props;

    return (
        <div className='paddle-hack-awards-f-wrapper'>
            <div className='paddle-hack-awards-f-content'>
                <div className='paddle-hack-awards-f-content-header'>
                    <img className='paddle-hack-awards-f-title' src={titleImageUrl} alt='' />
                    <div className='paddle-hack-awards-f-sub-title'>{subTitle ?? ''}</div>
                </div>
               
                <img className='paddle-hack-awards-f-comman' src={commonAwardsImg} alt='' />
                <div className='paddle-hack-awards-f-desc'>
                    {/* <span>{desc}</span> */}
                    <a href={detailLink} target='_blank' rel="noreferrer">&nbsp;&nbsp;查看详情&nbsp;<RightOutlined /></a>
                </div>
                {/* <div className='paddle-hack-awards-explain'>*以上奖项最终解释权归主办方所有</div> */}
            </div>
        </div>
    );
};

export default HackAwards;